export const SET_RESULTS = "SET_RESULTS";
